import React, {useEffect} from 'react'
import {KTSVG} from '../../../_metronic/helpers'

type Props = {
  className?: string
  handleDeleteModal: () => void
  setActive: (activeItem: string) => void
  activeItem: string
}

function DeleteButton({className, handleDeleteModal, setActive, activeItem}: Props) {
  useEffect(() => {
    console.log('borrr', activeItem)
  }, [activeItem])

  return (
    <button
      className={`btn btn-light-danger btn-sm px-4 py-1 text-uppercase ${className}`}
      onClick={() => {
        setActive(activeItem)
        handleDeleteModal()
      }}
    >
      <KTSVG
        path='/media/icons/duotune/general/gen027.svg'
        className='svg-icon-2 svg-icon-success m-0 '
      />
    </button>
  )
}

export default DeleteButton
